<template>
    <div id="o-growni" class="ServicesCrossroadBlock">
        <CHeading variant="2">
            <span class="text-white" :class="{ 'text-black dark:text-txt-headings': themeColoured }">
                {{ title }}
            </span>
        </CHeading>
        <div class="grid gap-6 sm:grid-cols-2" :class="threeCols ? 'lg:grid-cols-3' : 'lg:grid-cols-4'">
            <ServicesCrossroadCard
                v-for="(item, index) in items"
                :key="index"
                :item="item"
                :theme-coloured="themeColoured"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ServicesCrossroadIcons } from './ServicesCrossroadCard.vue'
import ServicesCrossroadCard from './ServicesCrossroadCard.vue'
import CHeading from '@/components/ui/CHeading.vue'

const props = defineProps({
    threeCols: {
        type: Boolean,
        default: false
    },
    themeColoured: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: 'Vyber si'
    },
    items: {
        type: Array,
        default: () => [
            {
                to: { name: 'praca' },
                title: 'Práca',
                type: ServicesCrossroadIcons.JOBS
            },
            {
                to: { name: 'praca', query: { job: 'staz_pre_studenta' } },
                title: 'Stáže',
                type: ServicesCrossroadIcons.INTERNSHIP
            },
            {
                to: { name: 'mentoring' },
                title: 'Mentoring',
                type: ServicesCrossroadIcons.MENTORING
            },
            {
                to: { name: 'vzdelavanie' },
                title: 'Vzdelávanie',
                type: ServicesCrossroadIcons.SKILLS
            },
            {
                to: { name: 'dobrovolnictvo' },
                title: 'Dobrovoľníctvo',
                type: ServicesCrossroadIcons.VOLUNTEERING
            },
            {
                to: { name: 'sebapoznanie' },
                title: 'Sebapoznanie',
                type: ServicesCrossroadIcons.SELF_KNOWLEDGE,
                titleTag: 'Spoznaj svoje silné stránky a limity. Pomôže to tvojmu rastu a osobnému rozvoju.'
            },
        ]
    }
})
</script>
